import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "../lib/api";

export default function WaCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [okPhone, setOkPhone] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    // Il WABA ID manuale viaggia nel suffisso "--w<ID>" dello state (Meta lo rimanda
    // identico): funziona anche quando Safari partiziona lo storage tra iframe e nuova
    // scheda. Il controllo anti-CSRF usa solo la parte base dello state.
    const rawState = params.get("state") || "";
    let state = rawState;
    let wabaFromState = null;
    const wSep = rawState.indexOf("--w");
    if (wSep > 0) {
      state = rawState.slice(0, wSep);
      wabaFromState = rawState.slice(wSep + 3) || null;
    }
    // Gli state vivono in localStorage come LISTA (piu' tentativi non si invalidano a
    // vicenda). Su Safari lo storage scritto dentro un iframe non e' leggibile dalla
    // nuova scheda (partizione): in quel caso la lista risulta vuota e si procede —
    // il code di Meta viene comunque validato dal backend nello scambio token.
    let states = [];
    try {
      states = JSON.parse(localStorage.getItem("wa_oauth_states") || "[]");
      const legacy = localStorage.getItem("wa_oauth_state") || sessionStorage.getItem("wa_oauth_state");
      if (legacy) states.push(legacy);
    } catch { /* storage non accessibile: procedi comunque */ }
    if (!code || !state || (states.length > 0 && !states.includes(state))) {
      setError("Ritorno da Meta non valido o sessione scaduta. Torna a Integrazioni e riprova il collegamento.");
      return;
    }
    // consuma gli state SOLO dopo la validazione: l'effetto puo' girare due volte
    // (StrictMode dev) e una rimozione anticipata farebbe passare il secondo giro
    sessionStorage.removeItem("wa_oauth_state");
    localStorage.removeItem("wa_oauth_state");
    localStorage.removeItem("wa_oauth_states");
    // WABA ID manuale: prima dallo storage, poi dal suffisso dello state (Safari-proof)
    let wabaId = wabaFromState;
    try { wabaId = localStorage.getItem("wa_oauth_waba") || wabaFromState; } catch { /* ignore */ }
    localStorage.removeItem("wa_oauth_waba");
    const redirectUri = `${window.location.origin}/whatsapp-callback`;
    const payload = { code, redirect_uri: redirectUri };
    if (wabaId) payload.waba_id = wabaId;
    api.post("/integrations/whatsapp/meta/connect", payload)
      .then((r) => {
        setOkPhone(r.data.phone_number || "il tuo numero");
        setTimeout(() => navigate("/integrazioni", { replace: true }), 1800);
      })
      .catch((e) => setError(apiError(e)));
  }, [navigate]);

  return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center p-4" data-testid="wa-callback-page">
      <div className="bg-white rounded-xl p-6 max-w-sm w-full text-center shadow-sm">
        {!error && !okPhone && (
          <>
            <div className="w-8 h-8 border-2 border-zinc-300 border-t-emerald-600 rounded-full animate-spin mx-auto" />
            <p className="text-sm text-zinc-600 mt-4">Collegamento di WhatsApp Business in corso...</p>
          </>
        )}
        {okPhone && (
          <>
            <div className="font-display text-lg font-bold text-emerald-700" data-testid="wa-callback-ok">
              WhatsApp Business collegato!
            </div>
            <p className="text-sm text-zinc-500 mt-1">{okPhone} · torno alle Integrazioni...</p>
          </>
        )}
        {error && (
          <>
            <div className="font-display text-lg font-bold text-rose-700" data-testid="wa-callback-error">
              Collegamento non riuscito
            </div>
            <p className="text-sm text-zinc-600 mt-2">{error}</p>
            <button onClick={() => navigate("/integrazioni", { replace: true })} data-testid="wa-callback-back"
              className="mt-4 h-10 px-5 rounded-md bg-zinc-900 text-white text-sm font-semibold">
              Torna a Integrazioni
            </button>
          </>
        )}
      </div>
    </div>
  );
}
